import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface BackButtonProps {
  label?: string;
  onClick?: () => void;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ 
  label = 'Back', 
  onClick,
  className = '' 
}) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };
  
  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-1 px-3 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg hover:bg-gray-100 ${className}`}
      style={{ minHeight: '44px', minWidth: '44px' }}
      aria-label={label}
    >
      <ChevronLeft className="w-5 h-5" />
      <span className="font-medium">{label}</span>
    </button>
  );
};